import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import Link from 'next/link'
import { ArrowRightOutlined, CloseOutlined } from '@ant-design/icons'

type CTAContent = {
  title: string
  desc: string
  btn: string
  link: string
}

type Props = {
  contentType: 'sm' | 'pm'
  content?: CTAContent
}

export default function CTA(props: Props) {
  const { contentType, content } = props
  const { t, i18n } = useTranslation('blog')

  const [visible, setVisible] = useState(false)

  const ctaContent = useMemo(() => {
    if (content?.title) {
      return content
    }
    const items = t(`cta.${contentType}`, { returnObjects: true }) as CTAContent[]
    const res = items[Math.floor(Math.random() * items.length)]
    return res
  }, [i18n.language, content])

  useEffect(() => {
    if (ctaContent) {
      setTimeout(() => {
        setVisible(true)
      }, 1000)
    }
  }, [ctaContent])

  return (
    visible && (
      <div
        className="section-container fixed bottom-4 -translate-x-1/2 hidden md:block"
        style={{ width: '100vw', marginLeft: '50%' }}
      >
        <div className="flex items-center py-4 px-6 bg-white border border-solid block-border rounded-lg shadow-sm">
          <div className="border border-solid block-border rounded-lg shadow-sm h-10 w-10 flex items-center justify-center mr-4">
            <Image
              src="/images/logo/icon.svg"
              className="h-6 w-auto"
              alt="Locker logo"
              height={24}
              width={21}
            />
          </div>

          <div className="flex-1 mr-4">
            <p className="text-lg text-black font-semibold">{ctaContent.title}</p>
            {!!ctaContent.desc && <p>{ctaContent.desc}</p>}
          </div>

          {!!ctaContent.link && (
            <Link target="_blank" href={ctaContent.link} className="mr-4">
              <div className="text-md font-medium text-white bg-primary rounded-lg hover:bg-primary-HOVER py-2 px-6 transition-colors text-center">
                {ctaContent.btn} <ArrowRightOutlined className="ml-1" />
              </div>
            </Link>
          )}
          <div className="p-2 cursor-pointer" onClick={() => setVisible(false)}>
            <CloseOutlined className="text-lg text-black" />
          </div>
        </div>
      </div>
    )
  )
}
